//---------------------
// calc item total enc
//---------------------
export default function calcItemTotalEnc({ character_item }) {
  console.log('---------------------------------')
  console.log('IN calcItemTotalEnc')
  console.log('character_item = ', character_item)
  console.log('processing item name = ', character_item.name)

  if (!character_item) return 0

  const encRaw = character_item.enc ?? 0
  const tally_qty = character_item.tally_qty ?? 0

  const enc = typeof encRaw === 'string' ? parseFloat(encRaw) : encRaw
  const qty = tally_qty > 0 ? tally_qty : 1

  // avoid floating point artefacts like 0.12999999999999998
  let tot_enc = enc * qty
  tot_enc = Math.round((tot_enc + Number.EPSILON) * 100) / 100 // 2 dp

  console.log(`enc = ${enc} x tally_qty = ${qty} = ${tot_enc}`)

  return tot_enc
}
